import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import RewardList from '../../../RnRCommonComponent/RewardList/rewardListPresentation';
import useMyBadgeAssignments from '../../hooks/useMyBadgeAssignments';
import useRewardDetails from '../../../RnRCommonComponent/RewardList/hooks/useRewardDetails';
import { BADGE_TYPE } from '../../../RnRCommonComponent/CoreBadge/rewardsConstants.js';
import { getActivityDisplayMode } from '../../utils/RecognitionModeUtils.js';

const MyBadgesList = (props) => {
	const {
		handleIconClickEvent,
		title = "My Recognitions",
		shouldRefresh,
		setShouldRefresh,
		isDetailsShown = false,
		isPointsShown = true,
		isIssuedVisible = true,
		currentUser,
		client
	} = props;

	const [isViewRewardModalVisible, setIsViewRewardModalVisible] = useState(false);

	const { rewardDetails, isModalLoaderVisible, handleOpenViewReward } = useRewardDetails(setIsViewRewardModalVisible, currentUser, client);

	const { isLoading, badgeList, hasMore, fetchMoreData } = useMyBadgeAssignments(currentUser, shouldRefresh, setShouldRefresh);

	// Check if we're in recognition mode to hide points
	const displayMode = getActivityDisplayMode(currentUser?.company);
	const isRecognitionMode = displayMode === 'recent_activity';
	const shouldShowPoints = isRecognitionMode ? false : isPointsShown;

	const handleCloseViewReward = () => {
		setIsViewRewardModalVisible(false);
	};

	return (
		<>
			{badgeList?.length > 0 ? (
				<RewardList
					handleIconClickEvent={handleIconClickEvent}
					title={title}
					badgeType={BADGE_TYPE.PEERTOPEER}
					hasMore={hasMore}
					isLoading={isLoading}
					badgeList={badgeList}
					fetchMoreData={fetchMoreData}
					isDetailsShown={isDetailsShown}
					isPointsShown={shouldShowPoints}
					handleCloseViewReward={handleCloseViewReward}
					isViewRewardModalVisible={isViewRewardModalVisible}
					rewardDetails={rewardDetails}
					isModalLoaderVisible={isModalLoaderVisible}
					handleOpenViewReward={handleOpenViewReward}
					getMyBadge={true}
					isIssuedVisible={isIssuedVisible}
				/>
			) : (
				<div className="d-card">
					<div className="d-card-head">
						<h4 className="d-title-no-case">{title}</h4>
					</div>
					<div className="d-card-body">
						<div className="no-badges-state" style={{ textAlign: 'center', padding: '40px 20px', color: '#666' }}>
							<div className="empty-state-icon" style={{ marginBottom: '16px' }}>
								<i className="fas fa-award" style={{ fontSize: '3rem', color: '#d9d9d9' }}></i>
							</div>
							<h3 style={{ margin: '0 0 8px 0', fontSize: '18px', fontWeight: '600', color: '#333' }}>
								No recognitions yet
							</h3>
							<p style={{ margin: '0', fontSize: '14px', color: '#999' }}>
								Your earned recognitions will appear here once approved.
							</p>
						</div>
					</div>
				</div>
			)}
		</>
	);
};

export default MyBadgesList;